import React from 'react';
import ReactDOM from 'react-dom';

import WLT0101_Master from './WLT0101-master';

const getNinushiDtlUrl = document.getElementById('ninushiDtlUrl').getAttribute("value").valueOf();

ReactDOM.render(
    <WLT0101_Master
        getNinushiDtlUrl={getNinushiDtlUrl}
     />
    ,document.getElementById("reissue_password"));


// WEBPACK FOOTER //
// ./view/WLT0101/WLT0101.jsx